import { InjectionToken } from "@angular/core";
import { FolderOperationService } from "src/app/api/services/folder-operation.service";
import { Schedule } from "src/app/api/services/schedule";
import { FolderService } from "src/app/shared/services/folder.service";
import { ScheduleService } from "../services/schedule.service";

export const provideScheduleFolderOperationService = () => ({
  provide: SCHEDULE_FOLDER_OPERATION_SERVICE,
  useFactory: (folderService: FolderService, scheduleService: ScheduleService) => {
    return new FolderOperationService(folderService, scheduleService);
  },
  deps: [FolderService, 'HasFolderStructure']
});

export const SCHEDULE_FOLDER_OPERATION_SERVICE = new InjectionToken<FolderOperationService<Schedule>>(
  'SCHEDULE_FOLDER_OPERATION_SERVICE'
);
